export default "__VITE_ASSET__CPffkshb__"